module.exports = __webpack_public_path__ + "img/titles12.ed43c3dd.png";